<ng-content></ng-content>

@if (isChevronShown) {
    <svg class="dropdown-button_toggle-menu-icon">
        <use xlink:href="#chevron-down"></use>
    </svg>
}
